import { render } from "./GetStarted.vue?vue&type=template&id=51e60abe&bindings={\"publicPath\":\"data\"}"
import script from "./GetStarted.vue?vue&type=script&lang=js"
export * from "./GetStarted.vue?vue&type=script&lang=js"
script.render = render

export default script